import React, { Component } from 'react';
import { Table, Breadcrumb, Row, Button } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { api, app } from "../../app";
import utils from "../../utils";

class DRanks extends Component {
    constructor(props) {
        super(props);
        // const province = props.match.params.province;
        const province = '广东';
        this.state = {
            token: '',
            data_loding: true,
            province: province,
            teamList: []
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.getTokeni();
        // this.dataSource(this.props.match.params.province);
        this.dataSource('广东');
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据源
     */
    dataSource = (province) => {
        const _this = this;
        app.post(api.TeamInfoDetail, { province }).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                _this.setState({ data_loding: false });
                if (flag === 1) {
                    _this.setState({ teamList: utils.addArrayKey(data) });
                    app.setData('link_province', province);
                } else {
                    app.alert(msg, "error");
                }
            }
        });
    }

    /**
* 获取token
* @returns {Promise<void>}
*/
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                token: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    render() {
        const columns = [
            {
                title: '队伍名称',
                dataIndex: 'teamname',
                key: 'teamname',
                width: '15%'
            },
            {
                title: '队长',
                dataIndex: 'teamheader',
                key: 'teamheader',
                width: '10%',
                render: (text, record) => {
                    const teamheader = record.teamheader;
                    if (teamheader.length > 0) {
                        const t = teamheader[0];
                        return (
                            <span><Link to={`/player/${record.team_id}/${t.indexno}?token=${this.state.token}`}
                                className="ranks_table_a">{teamheader[0].vname}</Link></span>
                        )
                    } else {
                        return (
                            <span>暂无</span>
                        )
                    }
                }
            },
            {
                title: '管理员',
                dataIndex: 'administrator',
                key: 'administrator',
                width: '23%',
                render: (text, record) => {
                    if (record.administrator.length > 0) {
                        return (
                            <span>
                                {
                                    record.administrator.map((s, index) => {
                                        return (
                                            <Link key={index + 1} to={`/player/${record.team_id}/${s.indexno}?token=${this.state.token}`}
                                                className="ranks_table_a">{s.vname}</Link>)
                                    })
                                }
                            </span>)
                    } else {
                        return (
                            <span>暂无</span>
                        )
                    }
                }
            },
            {
                title: '录入人数',
                dataIndex: 'count',
                key: 'count',
                width: '6%',
            },
            {
                title: '认证人数',
                dataIndex: 'RZcount',
                key: 'RZcount',
                width: '6%',
            },
            {
                title: '队员',
                dataIndex: 'DYcount',
                key: 'dy',
                width: '6%',
            },
            // {
            //     title: '预备队员',
            //     dataIndex: 'YBDYcount',
            //     key: 'YBDYcount',
            //     width: '6%',
            // },
            // {
            //     title: '认证志愿者',
            //     dataIndex: 'ZYZcount',
            //     key: 'ZYZcount',
            //     width: '6%',
            // },
            {
                title: '离队人员',
                dataIndex: 'LDcount',
                key: 'LDcount',
                width: '6%',
            },
            {
                title: '清退人员',
                dataIndex: 'KCcount',
                key: 'KCcount',
                width: '6%',
            },
            {
                title: '详情',
                dataIndex: '',
                key: 'xq',
                width: '10%',
                render: (text, record) => (
                    //{/*<span><Link to={"/ranks/detail/" + record.teamno} className="ranks_table_a">查看详情</Link></span>*/}
                    //<span><Link to={"/ranks/players/" + record.teamno} className="ranks_table_a">查看详情</Link></span>
                    <span><Link to={"/ranks/team/" + record.teamno} className="ranks_table_a">查看详情</Link></span>
                )
            },
        ], loading = this.state.data_loding,
            teamList = this.state.teamList,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无数据',
            };
        return (
            <div className="ranks_content">
                <Row type="flex" justify="space-between" className="r_page_title">
                    <div>队伍列表<span>Team list</span></div>
                    {/*<Button icon="rollback" onClick={() => app.backPage(this)}>返回</Button>*/}
                </Row>
                {/*<Breadcrumb separator=">" className="r_right_breadcrumb">*/}
                {/*    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>*/}
                {/*    <Breadcrumb.Item>{this.state.province}</Breadcrumb.Item>*/}
                {/*</Breadcrumb>*/}
                <Table className="ranks_table"
                    size="middle"
                    locale={locale}
                    columns={columns}
                    dataSource={teamList}
                    loading={loading}
                    pagination={false}
                    scroll={{ y: 'calc(100% - 46px)' }}
                />
            </div>
        );
    }
}

export default DRanks;



// WEBPACK FOOTER //
// ./src/routes/ranks/DRanks.jsx